import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ApplicantDashboard from './pages/ApplicantDashboard';
import NewApplication from './pages/NewApplication';
import NokmaDashboard from './pages/NokmaDashboard';
import JakrikraDashboard from './pages/JakrikraDashboard';
import AdminDashboard from './pages/AdminDashboard';

const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/applicant"
              element={
                <Protected roles={['applicant']}>
                  <ApplicantDashboard />
                </Protected>
              }
            />
            <Route
              path="/applicant/new"
              element={
                <Protected roles={['applicant']}>
                  <NewApplication />
                </Protected>
              }
            />
            <Route
              path="/nokma"
              element={
                <Protected roles={['nokma']}>
                  <NokmaDashboard />
                </Protected>
              }
            />
            <Route
              path="/jakrikra"
              element={
                <Protected roles={['jakrikra']}>
                  <JakrikraDashboard />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected roles={['admin']}>
                  <AdminDashboard />
                </Protected>
              }
            />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
